module.exports = __webpack_public_path__ + "static/media/pdf.ed2beadc.svg";